import { bookingInquiryApis } from '@apis/bookingInquiryApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useBookingInquiryDetail = createUseQuery(
  (d2d_no: string) => [`/booking-inquiry/${d2d_no}/`],
  (d2d_no) => () =>
    bookingInquiryApis
      .get('/booking-inquiry/{d2d_no}/', {
        path: { d2d_no },
      })
      .then((r) => r[200]!),
);
